import React, { useState } from "react";
import { setLoader } from "../../redux";
import { linkWithCredential, PhoneAuthProvider, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../firebase";
import { useDispatch } from "react-redux";
import { login } from "../../_services/auth/auth.service";
import { setSelfToken } from "../auth/secureToken";
import { useHistory } from 'react-router-dom';
import { RegisterUser } from "../../_services/register";
import { errorLogin } from "./errorLogin";

const useFirebaseAuthentication = ({ setConfirmationResult, confirmationResult, setReCAPTCHAToken, setErrorMsg, from, phoneNumber, otpCode, setTimer,setDisabledBtn, setOtpCode }) => {
    let history = useHistory();
    const dispatch = useDispatch();
    // State to hold the RecaptchaVerifier instance
    const [recaptchaVerifier, setRecaptchaVerifier] = useState(null);
    async function registerClickHandler(uid) {
        dispatch(setLoader(true));
        try {
            const response = await RegisterUser({ brand_auth: uid, policy: 'True' })

            if (response.status === 200) {
                dispatch(setLoader(false));
            }
            else {
                dispatch(setLoader(false));
            }
        }
        catch (error) {
            console.error("Error during login:", error);
        } finally {
            dispatch(setLoader(false));
        }
    }

    async function loginClickHandler(uid) {
        dispatch(setLoader(true));
        try {
            const response = await login({ username: uid });
            if (response.status === 200) {
                dispatch(setLoader(false));
                const output = response.data;
                if (output) {
                    setSelfToken(output.token);
                    history.replace(from.pathname);
                } else {
                    console.log(response);
                }
            }
            else {
                console.log(response.data.error);
                return response.data.error
            }
        } catch (error) {
            console.error("Error during login:", error);
        } finally {
            dispatch(setLoader(false));
        }
    }


    const sendOTP = async () => {
        if (!phoneNumber || phoneNumber.length < 10) {
            setErrorMsg("Invalid phone number");
            return;
        }

        dispatch(setLoader(true));
        try {
          
            let appVerifier = recaptchaVerifier;
            // Create RecaptchaVerifier only if it doesn't exist
            if (!appVerifier) {
                appVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                    size: 'invisible',
                    callback: (response) => {
                        console.log('reCAPTCHA solved:', response);
                        setReCAPTCHAToken(response);
                    },
                    'expired-callback': () => {
                        console.log('reCAPTCHA expired');
                    }
                });

                await appVerifier.render();
                setRecaptchaVerifier(appVerifier);
            }

            const result = await signInWithPhoneNumber(auth, '+' + phoneNumber, appVerifier);
            setOtpCode(Array(6).fill(""))
            dispatch(setLoader(false));
            setTimer(60);
            setConfirmationResult(result);
            setDisabledBtn(true);
            console.log('OTP sent!');
        } catch (error) {
            dispatch(setLoader(false));
            let errorMessage = errorLogin(error)
            setErrorMsg(errorMessage)
            console.error('Error sending OTP:', error.message);
        }
    };


    // ----------- verification otp --------------
    const verifyOTP = async () => {
        try {
            if (!confirmationResult) {
                console.error('No confirmation result found.');
                return;
            }

            const result = await confirmationResult.confirm(otpCode.join(""));
            // const uid = ""lpPdTPdBrFcAiUjw3Odil2taIHd2"";
            const uid = result.user.uid;
            // Attempt to login
            const loginResponse = await loginClickHandler(uid);
            console.log('OTP verified successfully!', loginResponse);

            if (loginResponse[0]) {
                console.warn("User not found. Attempting to register...");
                try {
                    await registerClickHandler(uid);
                    console.log("Registration successful. Logging in...");
                    await loginClickHandler(uid);
                } catch (registerError) {
                    console.error("Registration failed:", registerError);
                    let errorMessage = errorLogin(registerError)
                    setErrorMsg(errorMessage)
                }
            }
        } catch (otpError) {
            console.error('Error verifying OTP:', otpError.message);
            let errorMessage = errorLogin(otpError)
            setErrorMsg(errorMessage)
        }
    };

    return { sendOTP, verifyOTP, loginClickHandler, registerClickHandler };

}
export default useFirebaseAuthentication;